import {UniqueIdService} from '../../../shared/services/unique-id.service';
import {Variable} from '../../models/variable';
import {AssessmentResult} from '../../../shared/models/assessment-result';
import { Component, OnInit } from '@angular/core';
import { ScaleResult } from 'app/shared/models/scale-result';
import { Assessment } from 'app/shared/models/assessment';
import { Question } from 'app/shared/models/question';
import { ReportNavigationItem } from 'app/reports/models/report-navigation-item';
import { BaseReportItemComponent } from 'app/reports/models/base-report-item-component';

@Component({
  selector: 'app-flagged-questions-list',
  templateUrl: './flagged-questions-list.component.html'
})
export class FlaggedQuestionsListComponent extends BaseReportItemComponent implements OnInit {

  private _itemTitle:string;
  private _itemId:string;
  private _scales_per_page:number;
  private _assessments:Assessment[];
  private _questionsByAssessments:Map<Assessment, Question[]>;
  private _description:string;

  constructor() {
    super();
    this._questionsByAssessments = new Map<Assessment, Question[]>();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  /**
   * data => {
   * 'assessments' => [
   *   'assessment: 'dass-21', 'scale': '88....'
   *  ]
   * }
   * @param data 
   * @param results 
   * @param variables 
   */
  public setReportData(data:any, results:AssessmentResult[], variables:Variable[]) {
    if (!data || !results) {
      return;
    }
    this._itemTitle = data.title;
    this._description = data.description;

    if (data.assessments) {
      this._assessments = [];
      let assessments = data.assessments.forEach(c => {
        let result = results.find(r => r.assessment.uid == c);
        if (!result) {
          return;
        }
        let questions = result.assessment.getFlaggedQuestions();
        if (questions.length) {
          this._questionsByAssessments.set(result.assessment, questions);
          this._assessments.push(result.assessment);
        }
      });
    }
  }
  
  public shouldPrintBreak(index:number) {
    // since index is 0 based the the user scales per page is 1 based we convert.
    return ((index + 1) == this._scales_per_page);
  }

  get ScalesPerPage() {
    return this._scales_per_page;
  }

  get Assessments() {
    return this._assessments;
  }

  public getQuestionsForAssessment(assessment:Assessment) {
    return this._questionsByAssessments.get(assessment);
  }

  get hasFocusQuestions() {
    return this._questionsByAssessments.size > 0;
  }

  get description() {
    return this._description;
  }
  get title() {
    return this._itemTitle;
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/flagged-questions-list/flagged-questions-list.component.ts